import React, { useState } from 'react';
import history from 'routing/history';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import useTMLPowerformUrl from 'products/nomad_insurance/hooks/useTMPowerformUrl';
import useCurrentContract from 'products/nomad_insurance/hooks/useCurrentContract';
import SubmitClaimIcon from 'assets/img/icons/submit-claim.svg';
import { resetState } from 'products/nomad_insurance/views/ClaimsForm/state';
import ClaimProviderModal from 'products/nomad_insurance/components/ClaimProviderModal';
import { StyledButton as Button } from './styled';

const SubmitClaimButton = ({ color = 'porsche-2', fullWidth = true }) => {
  const { currentContract, hasBothWTAndSW } = useCurrentContract();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const navigateToClaims = () => {
    history.push('/nomad-insurance/claim');
  };

  const handleOnClick = () => {
    dispatch(resetState());
    if (hasBothWTAndSW) {
      setOpen(true);
    } else {
      navigateToClaims();
    }
  };

  return (
    <>
      <ClaimProviderModal isOpen={open} onClose={() => setOpen(false)} />
      <Button
        key="submitClaimButton"
        fullWidth={fullWidth}
        color={color}
        onClick={handleOnClick}
      >
        <img src={SubmitClaimIcon} alt="Submit claim icon" />
        Submit a new claim
      </Button>
    </>
  );
};

SubmitClaimButton.propTypes = {
  color: PropTypes.string,
  fullWidth: PropTypes.bool
};

export default SubmitClaimButton;
